import { Component, ChangeDetectionStrategy } from '@angular/core';
import { UserHeaderComponent } from '../../user-header/user-header.component';

@Component({
    selector: 'app-usergroup-list',
    imports: [
        UserHeaderComponent
    ],
    templateUrl: './usergroup-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './usergroup-list.component.scss'
})
export class UsergroupListComponent {

}
